module.exports = __webpack_public_path__ + "static/img/index-tip.70dca88c.png";